module.exports = {
          srcSet: __webpack_public_path__ + "61b76ab2b7ab4f4b8030eb7a5c739a23-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "61b76ab2b7ab4f4b8030eb7a5c739a23-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "61b76ab2b7ab4f4b8030eb7a5c739a23-120.png",
          toString:function(){return __webpack_public_path__ + "61b76ab2b7ab4f4b8030eb7a5c739a23-120.png"},
          
          width: 120,
          height: 120
        }